
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseItemsGrid extends Serenity.EntityGrid<PurchaseItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseItems'; }
        protected getDialogType() { return PurchaseItemsDialog; }
        protected getIdProperty() { return PurchaseItemsRow.idProperty; }
        protected getInsertPermission() { return PurchaseItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseItemsRow.localTextPrefix; }
        protected getService() { return PurchaseItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        //protected getSlickOptions() {
        //    let opt = super.getSlickOptions();
        //    opt.editable = true;
        //    opt.autoEdit = true;
        //    //opt.forceFitColumns = true;
        //    return opt;
        //}
        
    }
}